module.exports = __webpack_public_path__ + "static/media/main-banner.99da27d1.mp4";